import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const radioBoxDefaultVariants = {
  "size": "md"
}
const radioBoxCompoundVariants = []

const radioBoxSlotNames = [
  [
    "root",
    "radioBox__root"
  ],
  [
    "checkIcon",
    "radioBox__checkIcon"
  ],
  [
    "thumbnail",
    "radioBox__thumbnail"
  ],
  [
    "textGroup",
    "radioBox__textGroup"
  ],
  [
    "title",
    "radioBox__title"
  ],
  [
    "desc",
    "radioBox__desc"
  ]
]
const radioBoxSlotFns = /* @__PURE__ */ radioBoxSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, radioBoxDefaultVariants, getSlotCompoundVariant(radioBoxCompoundVariants, slotName))])

const radioBoxFn = memo((props = {}) => {
  return Object.fromEntries(radioBoxSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const radioBoxVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...radioBoxDefaultVariants, ...compact(variants) })

export const radioBox = /* @__PURE__ */ Object.assign(radioBoxFn, {
  __recipe__: false,
  __name__: 'radioBox',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: radioBoxVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, radioBoxVariantKeys)
  },
  getVariantProps
})